import { configureIguazuREST } from 'iguazu-rest';

const configureIguazuResources = () => {
  configureIguazuREST({
    getToState: (state) => state.getIn(['modules', 'axp-maps-travelers-cheques-root', 'resources']),
    // Add any other configuration values you already have (see https://github.com/americanexpress/iguazu-rest)
  });
};

configureIguazuResources();

export default configureIguazuResources;
